export function moveJobMenu() {
  const parent = document.querySelector('.js-move-wrap')
  const menu = document.querySelector('.c-specs__menu')
  const menuHeightOffset = menu ? menu.getBoundingClientRect().height : 0
  const parentOffsetTop = parent ? parent.offsetTop : 0
  const parentHeight = parent ? parent.getBoundingClientRect().height : 0
  const parentBottom = parentOffsetTop + parentHeight
  const navOffset = document.querySelector('.nav').getBoundingClientRect().height

  if (menu) {
    document.addEventListener('scroll', () => {
      const position = getComputedStyle(menu).position
      if (
        window.scrollY > parentOffsetTop - navOffset
        && window.scrollY < parentBottom - menuHeightOffset
        && position !== 'static'
      ) {
        const scrollInElement = window.scrollY - parentOffsetTop

        menu.setAttribute('style', `transform: translateY(${scrollInElement + navOffset}px)`)
      }
      if (position === 'static') {
        menu.setAttribute('style', 'transform: translateY(0px)')
      }
    })
  }
}
